<template>
  <div>
    <!-- Header -->
    <div class="relative bg-gray-900 h-screen">
      <!-- Decorative image and overlay -->
      <div
        aria-hidden="true"
        class="absolute inset-0 overflow-hidden shadow-md"
      >
        <img
          :src="menu.Header_Image"
          alt=""
          class="w-full h-full object-center object-cover"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        />
        <div aria-hidden="true" class="absolute inset-0 bg-black opacity-60" />
      </div>

      <div
        class="relative max-w-3xl mx-auto py-40 px-6 flex flex-col items-center text-center sm:py-30 sm:py-40 lg:px-0"
      >
        <div class="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8">
          <img class="h-10 mx-auto" src="@/assets/5.png" alt="" />
          <h1
            class="mt-5 mb-5 text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl"
          >
            <span class="block text-white">Menu.</span>
          </h1>
          <p class="rl text-white text-lg">Click on any menu below to view</p>
        </div>
      </div>
    </div>
    <!-- Header -->

    <!-- Menu Cards Section -->
    <div class="bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto">
        <!-- Menu Grid - 2 columns on desktop, 1 on mobile -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <!-- Brunch Menu Card -->
          <div
            @click="openMenu('brunch')"
            class="menu-card relative group cursor-pointer overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div class="aspect-w-3 aspect-h-4">
              <img
                :src="menuImages.brunch[0]"
                alt="Brunch Menu"
                class="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-300"
              />
              <!-- Dark Overlay -->
              <div
                class="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300"
              />
              <!-- Content -->
              <div
                class="absolute inset-0 flex flex-col items-center justify-center text-center p-4"
              >
                <h3 class="rl text-2xl font-bold text-white mb-2">
                  Brunch Menu
                </h3>
                <span
                  class="rl text-sg text-sm border-b border-sg pb-1 group-hover:border-white group-hover:text-white transition-colors duration-300"
                >
                  Click to View
                </span>
              </div>
            </div>
          </div>

          <!-- Dinner Menu Card -->
          <div
            @click="openMenu('dinner')"
            class="menu-card relative group cursor-pointer overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="aspect-w-3 aspect-h-4">
              <img
                :src="menuImages.dinner[0]"
                alt="Dinner Menu"
                class="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-300"
              />
              <!-- Dark Overlay -->
              <div
                class="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300"
              />
              <!-- Content -->
              <div
                class="absolute inset-0 flex flex-col items-center justify-center text-center p-4"
              >
                <h3 class="rl text-2xl font-bold text-white mb-2">
                  Dinner Menu
                </h3>
                <span
                  class="rl text-sg text-sm border-b border-sg pb-1 group-hover:border-white group-hover:text-white transition-colors duration-300"
                >
                  Click to View
                </span>
              </div>
            </div>
          </div>

          <!-- Dessert Menu Card -->
          <div
            @click="openMenu('dessert')"
            class="menu-card relative group cursor-pointer overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div class="aspect-w-3 aspect-h-4">
              <img
                :src="menuImages.dessert[0]"
                alt="Dessert Menu"
                class="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-300"
              />
              <!-- Dark Overlay -->
              <div
                class="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300"
              />
              <!-- Content -->
              <div
                class="absolute inset-0 flex flex-col items-center justify-center text-center p-4"
              >
                <h3 class="rl text-2xl font-bold text-white mb-2">
                  Dessert Menu
                </h3>
                <span
                  class="rl text-sg text-sm border-b border-sg pb-1 group-hover:border-white group-hover:text-white transition-colors duration-300"
                >
                  Click to View
                </span>
              </div>
            </div>
          </div>

          <!-- Drinks Menu Card -->
          <div
            @click="openMenu('drinks')"
            class="menu-card relative group cursor-pointer overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div class="aspect-w-3 aspect-h-4">
              <img
                :src="menuImages.drinks[0]"
                alt="Drinks Menu"
                class="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-300"
              />
              <!-- Dark Overlay -->
              <div
                class="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300"
              />
              <!-- Content -->
              <div
                class="absolute inset-0 flex flex-col items-center justify-center text-center p-4"
              >
                <h3 class="rl text-2xl font-bold text-white mb-2">
                  Drinks Menu
                </h3>
                <span
                  class="rl text-sg text-sm border-b border-sg pb-1 group-hover:border-white group-hover:text-white transition-colors duration-300"
                >
                  Click to View
                </span>
                <!-- Indicator for multiple pages -->
                <span class="rl text-white text-xs mt-2 opacity-75">
                  2 Pages
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Menu Cards Section -->

    <!-- Menu Viewer Modal - now with cross-menu navigation -->
    <MenuViewer
      :isOpen="viewerOpen"
      :initialMenuIndex="initialMenuIndex"
      @close="closeViewer"
    />

    <CTA />
  </div>
</template>

<script>
// src/views/Menu.vue
import axios from "axios";
import CTA from "@/components/CTA.vue";
import MenuViewer from "@/components/MenuViewer.vue";

export default {
  components: {
    CTA,
    MenuViewer,
  },
  data() {
    return {
      // Header image from Storyblok CMS
      menu: {
        Header_Image: "",
      },
      // Menu viewer modal state
      viewerOpen: false,
      // Index of menu to open (0=brunch, 1=dinner, 2=dessert, 3=drinks)
      initialMenuIndex: 0,
      // Menu images for card backgrounds (first image of each menu)
      menuImages: {
        brunch: ["/One-Squared-Menus-Dec-2025/One-Squared-Brunch-Menu.jpg"],
        dinner: ["/One-Squared-Menus-Dec-2025/One-squared-Dinner-Menu.jpeg"],
        dessert: ["/One-Squared-Menus-Dec-2025/One-Squared-Dessert-Menu.jpg"],
        drinks: ["/One-Squared-Menus-Dec-2025/Drinks-Menu-Page-1.jpg"],
      },
      // Menu type to index mapping
      menuIndexMap: {
        brunch: 0,
        dinner: 1,
        dessert: 2,
        drinks: 3,
      },
    };
  },

  methods: {
    // Fetch header image from Storyblok CMS
    getMenuPage() {
      let __this = this;
      axios
        .get(
          "https://api.storyblok.com/v2/cdn/stories/menu?cv=1657612129&token=e90vmTfGJpbIf0qqX2mihwtt&version=published"
        )
        .then((response) => {
          let content = response.data["story"]["content"];
          __this.menu = {
            Header_Image: content["Header_Image"]["filename"],
          };
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    // Open menu viewer with specific menu type
    openMenu(menuType) {
      this.initialMenuIndex = this.menuIndexMap[menuType];
      this.viewerOpen = true;
    },
    // Close menu viewer
    closeViewer() {
      this.viewerOpen = false;
    },
  },
  created() {
    this.getMenuPage();
  },
};
</script>

<style></style>
